import React from 'react'
import ResizablePanel from '../atoms/ResizablePanel'

const RenovationCard = ({ card, isOpen, isDisabled, onToggle }) => (
  <div
    className={`relative overflow-hidden bg-white shadow-box rounded-[5px] ${
      isDisabled && 'opacity-20'
    } transition-all`}
  >
    <ResizablePanel>
      <button
        type="button"
        className={`block w-full rounded-[5px] bg-white transition-all text-left overflow-hidden group`}
        onClick={onToggle}
      >
        {isOpen ? (
          <div className="w-full px-5 py-6">
            <div className="flex items-center justify-between pb-2 mb-6 font-bold border-b u-p border-gray-3">
              <span>{card.renovationCardTitle}</span>
              <div className="relative -top-4 -right-3 w-[30px] h-[30px] rounded-full bg-black flex flex-shrink-0 items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 22 22"
                >
                  <path
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 5l6 6-6 6M17 5l-6 6 6 6"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              className="prose u-p-small copy link-wrapper"
              dangerouslySetInnerHTML={{ __html: card.description }}
            />
          </div>
        ) : (
          <div className="w-full">
            <img src={card.image[0]?.url} alt="" className="w-full h-auto" />
            <div className="px-5 py-4 font-bold u-p group-hover:bg-red-as group-hover:text-white">
              {card.renovationCardTitle}
            </div>
          </div>
        )}
      </button>
    </ResizablePanel>
  </div>
)

export default RenovationCard
